import { format } from './format';

/**
 * Converte o valor de um campo numérico de formulário em número, aceitando os
 * dois formatos que circulam entre as telas:
 *   • vírgula decimal ("123,45"): inputs semeados com `format.plain` (modal de
 *     planta com a geração esperada calculada pelo PVGIS);
 *   • ponto decimal ("123.45" ou number): valores vindos da API (`toString()`).
 * Com vírgula, pontos são tratados como milhar e removidos. Vazio/inválido → 0.
 *
 * Caso que motivou (set/2026, UC Colônia): a geração esperada do modal chegava
 * como "123,45"; `Number("123,45")` é NaN — a tabela mostrava "NaN" e o backend
 * (`Number(x) || 0`) gravava 0 no mês. Espelho: frontend `utils/decimalInput.ts`
 * ⇄ backend `@shared/utils/decimalInput`.
 */
export function parseDecimalInput(value: unknown): number {
  if (value === null || value === undefined || value === '') return 0;
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  const s = String(value).trim();
  const normalized = s.includes(',')
    ? s.replace(/\./g, '').replace(',', '.')
    : s;
  const n = Number(normalized);
  return Number.isFinite(n) ? n : 0;
}

/**
 * Texto de um campo editável de kWh: fora de edição, inteiro com milhar; em
 * edição, o valor exato com vírgula (`numbersMask` remove pontos, então um ponto
 * decimal vindo da API viraria parte do número ao digitar). Ver `KwhInput`.
 */
export function kwhInputText(
  value: string | number | null | undefined,
  editing: boolean
): string {
  if (value === null || value === undefined || value === '') return '';
  return editing
    ? String(value).replace('.', ',')
    : format.energy(parseDecimalInput(value));
}
